/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DropdownCategories_allCategories$ref = any;
type IngredientsPage_allIngredients$ref = any;
export type queries_IngredientsPage_recipes_QueryVariables = {||};
export type queries_IngredientsPage_recipes_QueryResponse = {|
  +allCategories: ?{|
    +$fragmentRefs: DropdownCategories_allCategories$ref
  |},
  +$fragmentRefs: IngredientsPage_allIngredients$ref,
|};
export type queries_IngredientsPage_recipes_Query = {|
  variables: queries_IngredientsPage_recipes_QueryVariables,
  response: queries_IngredientsPage_recipes_QueryResponse,
|};
*/


/*
query queries_IngredientsPage_recipes_Query {
  allCategories {
    ...DropdownCategories_allCategories
  }
  ...IngredientsPage_allIngredients
}

fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
  edges {
    node {
      id
      name
      picture
    }
  }
}

fragment IngredientsPage_allIngredients on Query {
  allIngredients(first: 20) {
    totalCount
    edges {
      node {
        id
        name
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_IngredientsPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DropdownCategories_allCategories"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IngredientsPage_allIngredients"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "queries_IngredientsPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "IngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allIngredients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IngredientNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "allIngredients(first:20)"
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "name"
        ],
        "handle": "connection",
        "key": "Ingredients_allIngredients",
        "kind": "LinkedHandle",
        "name": "allIngredients"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_IngredientsPage_recipes_Query",
    "operationKind": "query",
    "text": "query queries_IngredientsPage_recipes_Query {\n  allCategories {\n    ...DropdownCategories_allCategories\n  }\n  ...IngredientsPage_allIngredients\n}\n\nfragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n      picture\n    }\n  }\n}\n\nfragment IngredientsPage_allIngredients on Query {\n  allIngredients(first: 20) {\n    totalCount\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3997542d17460cd58aaa28f33815d913';

module.exports = node;
